// new_dtime_frontend_vue_2026/src/services/api-dtime/api_forgot_password.js
// ไฟล์ใหม่
//
// แยกออกมาต่างหาก ไม่ต้องแก้ api.js / api_account.js เดิม (ลดความเสี่ยง)
// import ใช้ตรงๆ ในหน้า ForgotPasswordFlow.vue ได้เลย

import httpClient from "@/services/httpClient";

const BASE = "forgot-password";

// ขั้นตอนที่ 1: ส่ง OTP
export const requestOtp = (company_code, phone) => {
  return httpClient.post(`${BASE}/request`, { company_code, phone });
};

// ขั้นตอนที่ 2: ยืนยัน OTP
export const verifyOtp = (session_id, otp_code) => {
  return httpClient.post(`${BASE}/verify-otp`, { session_id, otp_code });
};

// กด Resend code
export const resendOtp = (session_id) => {
  return httpClient.post(`${BASE}/resend-otp`, { session_id });
};

// ขั้นตอนที่ 3: ตั้งรหัสผ่านใหม่
export const resetPassword = (reset_token, new_password, confirm_password) => {
  return httpClient.post(`${BASE}/reset-password`, {
    reset_token,
    new_password,
    confirm_password,
  });
};

export default {
  requestOtp,
  verifyOtp,
  resendOtp,
  resetPassword,
};
